import { formatError } from "@/helpers/filters";
import AuthService from "../services/auth-service";

export default {
  name: "InsertCode",

  data: () => ({
    dialogError: false,
    errorMessage: null,
    snackbar: false,
    snackbarColor: "info",
    snackbarMessage: "",
    shakeAnimated: false,
    code: '',
    userEmail: '',
    rulesCode: [
      (value) => !!value || "Obrigatório",
      (value) => (value && value.length >= 6) || "Min 6 caracteres",
    ],
  }),
  methods: {
   showToast(message, color = "info") {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbar = true;
    },
   redirectToRecoverPassword(email){
      if (email) {
        this.$store.state.user.email = email;
        this.$store.dispatch("auth/setEmail", email);
      }

      this.showToast("Sua conta precisa redefinir a senha antes do acesso.", "warning");

      setTimeout(() => {
        this.$router.push({
          path: "/recover-password",
          query: {
            ...this.$route.query,
            ...(email ? { email } : {}),
            reason: "first-login",
          },
        });
      }, 1000);
    },
   async insertCode(){
      const redirect = this.$route.query.redirect || "/dashboard/campaigns";
      const variables = {
        userEmail: this.$store.state.auth.emailUser || this.$store.state.user.email,
        code: this.code,
      }
      if (!variables.userEmail) {
        this.showToast("Informe seu e-mail antes de validar o código.", "warning");
        this.shakeAnimated = true;
        setTimeout(() => { this.shakeAnimated = false }, 1000);
      } else {
        try {
          const response = await AuthService.insertCode(variables)
          if (String(response?.code) === '403' && response?.message === 'FIRST_LOGIN_REDIRECT') {
            this.redirectToRecoverPassword(variables.userEmail)
            return
          }
          this.$router.push(redirect)
        } catch (error) {
          this.errorMessage = formatError(error.message)
          this.dialogError = true
          setTimeout(() => { this.dialogError = false }, 3000)
        }
      }
    }
  },
};